import { useTranslation } from "react-i18next";

/**
 * Заметка при достижении отметки прибыли. Figma: `Trust Note` (19:204).
 *
 * Существует ради дисциплины из документации компонента Banner в макете:
 * «Never imply guaranteed returns» — рост не должен читаться как обещание.
 */
export function TrustNote() {
  const { t } = useTranslation();

  return (
    <section className="flex w-full flex-col gap-1.5 rounded-[20px] border border-border-subtle bg-background-raised p-4">
      <h2 className="text-body font-semibold text-text-primary">{t("home.trustNote.title")}</h2>
      <p className="text-caption font-normal text-text-secondary">{t("home.trustNote.body")}</p>
    </section>
  );
}
